<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import * as Common from "../utiles/common.util";
    import * as store from "../stores/store";
    import { push } from "svelte-spa-router";
    import { Capacitor } from "@capacitor/core";
    import { PushNotifications } from "@capacitor/push-notifications";
    import { get } from "svelte/store";
    import { Preferences } from "@capacitor/preferences";

    let id = "";
    let pw = "";
    let loading = false;
    let isDarkMode = false;

    onMount(() => {
        // 로그인 상태 체크
        apiGetStatus();

        // 초기 테마 설정
        const savedTheme = localStorage.getItem('theme');
        if (savedTheme === 'dark' || (!savedTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            isDarkMode = true;
            document.documentElement.setAttribute('data-theme', 'dark');
        }
    });

    function toggleTheme() {
        isDarkMode = !isDarkMode;
        if (isDarkMode) {
            document.documentElement.setAttribute('data-theme', 'dark');
            localStorage.setItem('theme', 'dark');
        } else {
            document.documentElement.removeAttribute('data-theme');
            localStorage.setItem('theme', 'light');
        }
    }

    async function apiGetStatus() {
        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive !== "granted") {
                // alert("푸시 알림 권한이 거부되었습니다.");
                return;
            }
        }

        const token = await Common.getStoredToken();

        if (token) {
            if (location.href.includes("Login")) {
                push("/AsList");
            }
        } else {
            if (!location.href.includes("Login")) {
                push("/Login");
            }
        }
    }

    async function login() {
        if (loading) return;
        if (Common.nullCheck(id, "id", "아이디")) return;
        if (Common.nullCheck(pw, "pw", "비밀번호")) return;

        loading = true;
        try {
            const fcm_token = get(store.fcm_token);
            const formData = {
                id,
                pw,
                role: "REPAIR",
                fcm_token,
            };

            const response = await api.post("/account/login", formData);

            if (response != null) {
                store.accountInfo.set(response.data);
                store.jwt_token.set(response.token.accessToken);
                store.refreshToken.set(response.token.refreshToken);

                await Preferences.set({
                    key: "jwt_token",
                    value: response.token.accessToken,
                });
                await Preferences.set({
                    key: "refreshToken",
                    value: response.token.refreshToken,
                });
                await Preferences.set({
                    key: "accountInfo",
                    value: JSON.stringify(response.data),
                });

                push("/AsList");
            }
        } catch (error) {
            console.error("Login failed:", error);
            // 필요 시 에러 알림 처리 (api.post 내부에서 처리하지 않을 경우)
        } finally {
            loading = false;
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<section class="login-section">
    <div class="login">
        <div class="login-container">
            <div class="login-info-container">
                <div class="login-title">
                    <p class="login-title-top">
                        A/S 이력관리시스템
                    </p>
                    <p class="login-title-btm">기사용</p>
                </div>

                <div class="login-form-group">
                    <label for="login-id">ID</label>
                    <input
                        id="login-id"
                        type="text"
                        class="id"
                        placeholder="아이디를 입력해주세요"
                        maxlength="11"
                        bind:value={id}
                        disabled={loading}
                        on:keypress={(e) => {
                            e.key === "Enter" ? login() : "";
                        }}
                    />
                </div>

                <div class="login-form-group" style="margin-bottom: 20px">
                    <label for="login-pw">PASSWORD</label>
                    <input
                        id="login-pw"
                        type="password"
                        class="pw"
                        placeholder="비밀번호를 입력해주세요"
                        maxlength="20"
                        bind:value={pw}
                        disabled={loading}
                        on:keypress={(e) => {
                            e.key === "Enter" ? login() : "";
                        }}
                    />
                </div>
                
                <button class="btn-login" on:click={login} disabled={loading}>
                    {#if loading}
                        로그인 중...
                    {:else}
                        LOG IN
                    {/if}
                </button>
            </div>
            
            <div class="theme-toggle">
                <button on:click={toggleTheme} class="btn-theme" disabled={loading}>
                    {#if isDarkMode}
                        ☀️ 라이트 모드로 보기
                    {:else}
                        🌙 다크 모드로 보기
                    {/if}
                </button>
            </div>
        </div>
    </div>
</section>

<style>
    .login-section {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 100vh;
        padding: 20px;
        background-color: var(--bg-color);
        transition: background-color 0.3s ease;
    }
    
    .login-container {
        width: 100%;
        max-width: 400px;
        background-color: var(--card-bg);
        border-radius: 16px;
        padding: 40px 30px;
        box-shadow: var(--shadow-md);
        display: flex;
        flex-direction: column;
        gap: 20px;
    }

    .login-title {
        text-align: center;
        margin-bottom: 30px;
    }

    .login-title-top {
        font-size: 1.5rem;
        font-weight: 700;
        color: var(--text-color);
        margin: 0;
        margin-bottom: 8px;
    }

    .login-title-btm {
        display: inline-block;
        font-size: 0.9rem;
        font-weight: 600;
        color: #ffffff; /* 가독성을 위해 흰색으로 고정 */
        background-color: var(--primary-color);
        padding: 4px 12px;
        border-radius: 20px;
        margin: 0;
    }

    .login-form-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
        margin-bottom: 15px;
    }
    
    .login-form-group label {
        font-size: 0.85rem;
        font-weight: 600;
        color: var(--text-color);
        opacity: 0.8;
    }

    .login-form-group input {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid var(--input-border);
        border-radius: 8px;
    }

    .btn-login {
        width: 100%;
        padding: 14px;
        font-size: 1rem;
        font-weight: bold;
        background-color: var(--primary-color);
        color: #ffffff;
        border-radius: 8px;
        margin-top: 10px;
        box-shadow: var(--shadow-sm);
    }
    
    .btn-login:disabled {
        opacity: 0.7;
        cursor: not-allowed;
        background-color: var(--btn-bg);
        color: var(--btn-text);
    }

    .theme-toggle {
        margin-top: 20px;
        text-align: center;
    }

    .btn-theme {
        background: none;
        border: 1px solid var(--input-border);
        color: var(--text-color);
        padding: 8px 16px;
        border-radius: 20px;
        font-size: 0.85rem;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        transition: all 0.2s ease;
    }

    .btn-theme:hover {
        background-color: var(--input-bg);
    }
</style>
